module.exports = __webpack_public_path__ + "img/btn_mobysign_signin_normal.b1cb7db2.svg";